// Bookmark / Save favorite sentences system

export function getBookmarks() {
  try { return JSON.parse(localStorage.getItem("bookmarks") || "[]"); } catch { return []; }
}

export function addBookmark(sentence, source, day) {
  const bookmarks = getBookmarks();
  if (bookmarks.some((b) => b.sentence === sentence)) return false;
  bookmarks.unshift({ sentence, source, day, savedAt: new Date().toISOString() });
  localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
  return true;
}

export function removeBookmark(sentence) {
  const bookmarks = getBookmarks().filter((b) => b.sentence !== sentence);
  localStorage.setItem("bookmarks", JSON.stringify(bookmarks));
}

export function isBookmarked(sentence) {
  return getBookmarks().some((b) => b.sentence === sentence);
}
